import React from 'react';
import { motion } from 'framer-motion';
import { loopPhases, serviceGroups } from '../../data/supportLoop';
export function SupportLoop() {
  return <section id="ongoing" className="relative overflow-hidden bg-mist-100 py-14 text-navy-900 lg:py-20" data-id="element-257" data-mp="2iff5stvqgpqr">
      <div className="absolute inset-0 bp-light" aria-hidden="true" data-id="element-258" data-mp="2neidkm33la2f" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-259" data-mp="2reskq22mm6iv">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-260" data-mp="2wdvm9cjedum3">
          <div className="min-w-0 lg:col-span-7" data-id="element-261" data-mp="31c6yftx60h7h">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-navy-600" data-id="element-262" data-mp="31avspok5szdq">Ongoing management</p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-[1.12] tracking-[-0.02em] text-navy-900 sm:text-[2.1rem]" data-id="element-263" data-mp="363oz0gva0frx">
              Launch is a milestone. Accountability continues.
            </h2>
          </div>
          <p className="min-w-0 text-[14.5px] leading-relaxed text-navy-700/80 lg:col-span-5" data-id="element-264" data-mp="3k2od4ul5xc9u">
            WebsiteForge stays involved to keep the system secure, current, visible, and aligned with the business. Support
            requests, reporting, search performance, and customer behavior inform what we improve next.
          </p>
        </div>

        <ol className="mt-9 grid gap-px overflow-hidden rounded-2xl bg-navy-900/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-265" data-mp="1v8f2azoffdqp">
          {loopPhases.map((phase, i) => <motion.li key={phase.index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="min-w-0 bg-white p-6" data-id="element-266" data-mp="2nwsxz8s1lxz3" data-mpi={i}>
              <span className="font-mono text-[12px] tracking-[0.12em] text-forge-orange" data-id="element-267" data-mp="296d8hhslg3v4">{phase.index}</span>
              <h3 className="mt-2 font-display text-[16px] font-bold text-navy-900" data-id="element-268" data-mp="36nkcspusugkv">{phase.title}</h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-navy-700/75" data-id="element-269" data-mp="31uhk0jxujb5q">{phase.body}</p>
            </motion.li>)}
        </ol>

        <div className="mt-6 grid gap-4 rounded-2xl bg-ink px-6 py-7 sm:grid-cols-3 lg:px-9" data-id="element-270" data-mp="1403wq36syxnp">
          {serviceGroups.map(group => <div key={group.title} className="min-w-0" data-id="element-271" data-mp="q7np0p2yibgg">
              <p className="font-mono text-[11.5px] uppercase tracking-[0.16em] text-forge-cyan" data-id="element-272" data-mp="v7tnop7n8y81">{group.title}</p>
              <ul className="mt-3 space-y-2" data-id="element-273" data-mp="ga1aw4thenxj">
                {group.items.map(item => <li key={item} className="min-w-0 text-[13.5px] leading-snug text-mist-100" data-id="element-274" data-mp="l9dyirs6fz16">
                    {item}
                  </li>)}
              </ul>
            </div>)}
        </div>

        <p className="mt-5 font-display text-[15px] font-bold text-navy-900" data-id="element-275" data-mp="c9z6hnwd3gek">
          WebsiteForge remains accountable after launch.
        </p>
      </div>
    </section>;
}